export * from './photoCapture';
export { default } from './photoCapture';
